import request from "@/service";

/* 查询所有公告列表 */
export function getNoticeParamList(params) {
  return request({
    url: `/sys/pub/notice/page`,
    params,
    method: "get"
  });
}

/* 新增公告 */
export function noticeSave(data) {
  return request({
    url: `/sys/pub/notice/save`,
    method: "post",
    data
  });
}

/* 修改公告 */
export function noticeUpdate(data) {
  return request({
    url: `/sys/pub/notice/update`,
    method: "put",
    data
  });
}

/* 删除公告 */
export function noticeDel(data) {
  return request({
    url: `/sys/pub/notice/delete`,
    method: "delete",
    data
  });
}

/* 上架下架 */
export function noticeOnline(data) {
  return request({
    url: `/sys/pub/notice/online`,
    method: "put",
    data
  });
}

/* 是否置顶 */
export function noticeTop(data) {
  return request({
    url: `/sys/pub/notice/top`,
    method: "put",
    data
  });
}

/* 公告详情 */
export function noticeDetail(data) {
  return request({
    url: `/sys/pub/notice/info/${data}`,
    method: "get"
  });
}

export function noticeDownload(data) {
  return request({
    url: '/sys/portal/pub/notice/download',
    data,
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
  })
}

// 列表上，共享按钮
export function saveShareList(data) {
  return request({
    url: `/sys/pub/notice/saveShareList`,
    method: "post",
    data
  });
}

export function recoverShareList(data) {
  return request({
    url: `/sys/pub/notice/recoverShareList`,
    method: "post",
    data
  });
}

export function noticeShareList(data) {
  return request({
    url: `/sys/pub/notice/shareList`,
    method: "post",
    data
  });
}

export function cancelShareList(data) {
  return request({
    url: `/sys/pub/notice/cancelShareList`,
    method: "post",
    data
  });
}
